import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl1FormDataToModel,
  convertModelToBefehl1FormData
} from './converters'
import Auftrag1_10Form from './Auftrag1_10Form'
import { useBefehlForm } from '../../../hooks'
import { Befehl1 } from '../../../models'
import { Befehl1FormData, createBefehl1FormValidationSchema } from './schema'
import { AuftragX_25Form, AuftragX_95Form } from '../Auftraege'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'

/**
 * Main form component for Befehl 1
 */
export default function Befehl1Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-1-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl1>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl1FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl1FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl1FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl1FormData) => {
      const updatedBefehl = convertBefehl1FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl1FormData>
      befehlKennung="1"
      title={t('befehle.1.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 1.10 */}
      <Auftrag1_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-1-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      {/* Auftrag 1.25 */}
      <AuftragX_25Form
        befehlKennung="1"
        fieldNamePrefix="auftrag_1_25"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-1-25`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      {/* Auftrag 1.95 */}
      <AuftragX_95Form
        befehlKennung="1"
        fieldNamePrefix="auftrag_1_95"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-1-95`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
